import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';
import AntGridScope, { buildGridScopeSegment } from './AntGridScope';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import { unpack, pack } from 'msgpackr';
import stringify from '../utils/stableStringify';
import Calculator from '../utils/calculator';
import AntCondition from '../utils/AntCondition';
import AntLocalization from '../utils/AntLocalization';
import AntPopup from './AntPopup';
import AntBaseForm from './AntBaseForm';
import AntGrid from './AntGrid';
import AntConfig from '../utils/AntConfig';

import { AntGlobal, AntSession } from '../utils/AntContext';

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();
    // const session = AntSession();
    // const location = useLocation();
    const navigate = useNavigate();

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const mainTable = props.table ? props.table : props.API ? props.API.entityName : '';
    // const mainEntityName = props.API && props.API.entityName ? props.API.entityName : '';
    const mainEntityDisplay = props.API && props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay ? props.entityDisplay : '';

    // const mainConfig = useMemo(() => {
    //     let cnf = new AntConfig(appGlobal, mainTable);
    //     cnf.configFields(props.fields);
    //     return cnf;
    // }, []);

    const show = async (objDefault) => {
        if (!popup.current) return;

        let obj = { ...objDefault };

        Object.keys(obj).forEach((k) => {
            if (obj[k] === undefined) delete obj[k];
        });

        var preparedObj = null;
        // if (props.prepare !== false && props.API && props.API.postCreatePrepare) {
        //     preparedObj = await props.API.postCreatePrepare(obj, props.prepareConditions);
        // }

        preparedObj = { ...preparedObj, ...props.defaultObj, ...obj };
        forceRenderWithState({ error: null, searchConditions: {} });
        if (props.onPrepared) await props.onPrepared(preparedObj);
        forceRenderWithData(preparedObj, true);

        if (grid.current) await grid.current.cleanData();
        popup.current.show();

        return;
    };

    const [mainData, setMainData] = useState({});

    const popup = useRef();
    const grid = useRef();
    const header = useRef();
    const footer = useRef();

    const setError = (content, errors) => {
        if (!content && (mainState.error === null || mainState.error === undefined)) return;
        if (errors == 'TypeError: Failed to fetch') errors = { vi: 'Không thể kết nối đến hệ thống !', en: 'Can not connect to system !', fr: 'Impossible de se connecter au système !', es: '¡No se puede conectar al sistema!', id: 'Tidak dapat terhubung ke sistem!', ja: 'システムに接続できません！', zh: '无法连接到系统！', ko: '시스템에 연결할 수 없습니다!', hi: 'सिस्टम से कनेक्ट नहीं हो सकता!', ar: 'لا يمكن الاتصال بالنظام!' };
        var values = errors === undefined || errors === null ? [] : errors instanceof Array ? errors : [errors];

        content = values.length === 1 ? values[0] : content;
        forceRenderWithState({
            error: content
                ? {
                      text: String(content),
                      values: values
                  }
                : null
        });
        if (props.onError) props.onError(content, errors);
    };

    const initHeader = useCallback(
        (formData) => {
            var isVisibleHeader = props.header && AntCondition.isVisible(formData, props.header);

            var headerColCount = undefined;
            if (props.header) {
                headerColCount = AntCondition.getValue(formData, props.header.colCount);
                if (headerColCount === undefined) headerColCount = props.header.colCountDefault ? props.header.colCountDefault : 1;
            }
            var headerItems = props.header && props.header.items instanceof Array ? props.header.items : [];
            headerItems = JSON.parse(stringify(headerItems));
            headerItems = headerItems.filter((item) => {
                return AntCondition.isVisible(formData, item);
            });

            var sumSpan = headerItems.reduce((total, current) => {
                var colSpan = AntCondition.getValue(formData, current.colSpan);
                if (colSpan === undefined) colSpan = current.colSpanDefault;

                return total + (colSpan !== undefined ? parseInt(colSpan) : 1);
            }, 0);

            var headerLineCount = Math.ceil(sumSpan / headerColCount);
            var headerHeight = 0;
            if (isVisibleHeader && headerLineCount > 0) {
                headerHeight = headerLineCount * 36 + (headerLineCount - 1) * 10;
                headerHeight += headerItems.reduce((total, current) => {
                    return total + (current.options && current.options.height > 36 ? parseInt(current.options.height) - 36 : 0);
                }, 0);
            }

            return {
                headerItems: headerItems,
                headerLineCount: headerLineCount,
                headerHeight: headerHeight,
                headerVisible: isVisibleHeader
            };
        },
        [props.header]
    );

    const initFooter = useCallback(
        (formData) => {
            var isVisibleFooter = props.footer && AntCondition.isVisible(formData, props.footer);

            var footerColCount = undefined;
            if (props.footer) {
                footerColCount = AntCondition.getValue(formData, props.footer.colCount);
                if (footerColCount === undefined) footerColCount = props.footer.colCountDefault ? props.footer.colCountDefault : 1;
            }

            var footerItems = props.footer && props.footer.items instanceof Array ? props.footer.items : [];
            footerItems = JSON.parse(stringify(footerItems));
            footerItems = footerItems.filter((item) => {
                return AntCondition.isVisible(formData, item);
            });

            var sumSpan = footerItems.reduce((total, current) => {
                var colSpan = AntCondition.getValue(formData, current.colSpan);
                if (colSpan === undefined) colSpan = current.colSpanDefault;

                return total + (colSpan !== undefined ? parseInt(colSpan) : 1);
            }, 0);

            var footerLineCount = Math.ceil(sumSpan / footerColCount);
            var footerHeight = 0;
            if (isVisibleFooter && footerLineCount > 0) {
                footerHeight = footerLineCount * 36 + (footerLineCount - 1) * 10;
                footerHeight += footerItems.reduce((total, current) => {
                    return total + (current.options && current.options.height > 36 ? parseInt(current.options.height) - 36 : 0);
                }, 0);
            }

            return {
                footerItems: footerItems,
                footerLineCount: footerLineCount,
                footerHeight: footerHeight,
                footerVisible: isVisibleFooter
            };
        },
        [props.footer]
    );

    const initGrid = useCallback(
        (formData) => {
            var gridCols = props.grid && props.grid.columns instanceof Array ? props.grid.columns : [];
            gridCols = JSON.parse(stringify(gridCols));

            var gridRawCols = props.grid && props.grid.columns instanceof Array ? props.grid.columns : [];
            gridRawCols = JSON.parse(stringify(gridRawCols));

            gridCols = gridCols.filter((col) => {
                return AntCondition.isRender(formData, col);
            });

            gridCols.forEach((col) => {
                // if (typeof col.visible !== 'object' || col.visible.type !== 'action' || !col.visible.field)

                col.rawConfig = JSON.parse(stringify(col));
                col.visible = AntCondition.isVisible(formData, col);
                col.editable = AntCondition.isEditable(formData, col);
            });

            var gridStorageKey = props.name
                ? props.name
                : props.entityName
                ? props.entityName
                : props.API && props.API.entityName
                ? props.API.entityName
                : null;
            gridStorageKey = gridStorageKey ? 'batchCreation-' + gridStorageKey : undefined;

            var url = props.grid && props.grid.url ? props.grid.url : '';

            var searchFields = [];
            if (props.grid && props.grid.searchByHeaderFields instanceof Array)
                props.grid.searchByHeaderFields.forEach((f) => {
                    searchFields.push(f);
                });
            if (props.grid && typeof props.grid.searchConditions === 'object' && props.grid.searchConditions !== null) {
                Object.keys(props.grid.searchConditions).map((f) => {
                    searchFields.push(f);
                });
            }
            if (props.grid && props.grid.postFields instanceof Array)
                props.grid.postFields.forEach((f) => {
                    searchFields.push(f);
                });
            if (props.grid && props.grid.postRequiredFields instanceof Array)
                props.grid.postRequiredFields.forEach((f) => {
                    searchFields.push(f);
                });

            return {
                gridRawCols: gridRawCols,
                gridCols: gridCols,
                gridSearchFields: searchFields,
                gridURL: url,
                gridStorageKey: gridStorageKey,
                gridVisible: Boolean(props.grid),
                gridDisabled: Boolean(props.grid) && AntCondition.isDisable(formData, props.grid)
            };
        },
        [props.grid]
    );

    const initPopupSize = () => {
        var minHeight;

        if (props.height instanceof Array) {
            for (let i = 0; i < props.height.length; i++) {
                const e = props.height[i];
                if (e && typeof e.when === 'object' && e.when !== null && e.value !== undefined) {
                    var isValid = AntCondition.isValid(mainData, {
                        when: e.when,
                        whenType: e.whenType
                    });
                    if (isValid) {
                        minHeight = parseFloat(e.value);
                        break;
                    }
                }
            }
        } else if (typeof props.height === 'number') minHeight = parseFloat(props.height);

        // if (!minHeight) minHeight = 500;

        var height = 0;

        if (props.grid) {
            var hBeforeSeperator = mainHeader.headerVisible ? 10 : 0;
            var hAfterSeperator = mainFooter.footerVisible ? 30 : 0;
            var hActionBar = 46;
            var hColHeader = 31;
            var hPager = 44;
            var hRow = 34;
            var hSeprator = 0;
            var defaultPageSize = 0;

            if (props.grid && props.grid.defaultPageSize && props.grid.defaultPageSize > defaultPageSize)
                defaultPageSize = props.grid.defaultPageSize;

            if (!defaultPageSize) defaultPageSize = 8;

            var showActionBar = props.grid.showActionBar !== undefined ? props.grid.showActionBar : true;
            var rowsNum = defaultPageSize;

            if (grid.current && grid.current.isDataLoaded()) {
                var rows = grid.current.getCachedData();
                if (rows.length === 0) rowsNum = 0;
                else if (rows.length < defaultPageSize) rowsNum = rows.length;
                if (rowsNum > 0 && rowsNum < 2) rowsNum = 2;
            }

            var gridHeight = mainGrid.gridVisible
                ? hBeforeSeperator +
                  (showActionBar ? hActionBar : 0) +
                  hColHeader +
                  hPager +
                  //   (rowsNum === 0 ? 130 : hRow * rowsNum) +
                  hRow * defaultPageSize +
                  hSeprator +
                  hAfterSeperator
                : 0;

            if (grid.current) {
                var arCat = grid.current.getSearchCategories();
                // console.log('ant-log-arCat : ', arCat);
                gridHeight += arCat.length * 60;
            }

            height += gridHeight;
        }

        height += mainHeader && mainHeader.headerHeight ? parseFloat(mainHeader.headerHeight) : 0;
        height += mainFooter && mainFooter.footerHeight ? parseFloat(mainFooter.footerHeight) : 0;
        height += 10 + 46 + 20 + 47;
        height += 10;

        if (minHeight && height < minHeight) height = minHeight;

        var width = AntCondition.getValue(mainData, props.width);
        if (width === undefined) width = props.widthDefault;
        if (width === undefined) width = 900;

        return {
            width: width,
            height: height + 30
        };
    };

    const getSearchConditions = () => {
        var obj = { ...mainState.searchConditions };

        if (props.grid.searchByHeaderFields instanceof Array) {
            props.grid.searchByHeaderFields.forEach((field) => {
                if (typeof field === 'object') {
                    var parentField = field.field;
                    var aliasField = field.alias ? field.alias : field.field;

                    if (mainData && mainData[parentField] !== undefined) obj[aliasField] = mainData[parentField];
                } else if (mainData && mainData[field] !== undefined) obj[field] = mainData[field];
            });
        }

        if (props.grid && props.grid.searchConditions) obj = { ...obj, ...props.grid.searchConditions };

        return obj;
    };

    const isAllowQuery = () => {
        var isAllow = popup.current && popup.current.isShowing();
        if (!isAllow) return false;

        if (props.grid.searchByHeaderRequiredFields instanceof Array) {
            props.grid.searchByHeaderRequiredFields.forEach((field) => {
                if (typeof field === 'object') {
                    var parentField = field.field;
                    if (!mainData || mainData[parentField] === undefined || mainData[parentField] === null) isAllow = false;
                } else if (!mainData || mainData[field] === undefined || mainData[field] === null) isAllow = false;
            });
        }

        if (!isAllow) return false;

        if (props.isAllowQuery && typeof props.isAllowQuery === 'function') isAllow = props.isAllowQuery();

        return isAllow;
    };

    const onFieldDataChanged = async (e, newData) => {
        if (props.onFieldDataChanged) {
            var isValid = await props.onFieldDataChanged(e);
            if (!isValid) return;
        }

        forceRenderWithData(newData);
    };

    const updateRowToMain = async (rowDatas, col) => {
        var ar = [];
        if (typeof col.updateToMain === 'object') ar.push(col.updateToMain);
        if (col.updateToMain instanceof Array) ar.push(...col.updateToMain);

        for (let i = 0; i < ar.length; i++) {
            var rule = ar[i];

            if (rule && rule.target) {
                var targetField = rule.target;
                var calcType = rule.type;
                var targetValue = null;
                if (calcType === 'SUM') {
                    if (rule.cellFormula instanceof Array) {
                        var fm = rule.cellFormula[0];
                        var defaultNullValue =
                            rule.cellFormula[1] !== undefined && rule.cellFormula[1] !== null && typeof rule.cellFormula[1] === 'number'
                                ? rule.cellFormula[1]
                                : 0;

                        targetValue = rowDatas.reduce((total, current) => {
                            return total + Calculator.execNum(current, fm, defaultNullValue);
                        }, 0);
                    } else {
                        targetValue = rowDatas.reduce((total, current) => {
                            return total + parseFloat(current[col.dataField]);
                        }, 0);
                    }
                    forceRenderWithData({
                        [targetField]: targetValue
                    });
                }
            }
        }
    };

    const onGridCellValueChanged = (colField, values) => {
        if (grid.current) {
            var keyField = grid.current.getKeyField();
            var data = grid.current.getEditedData();
            if (data instanceof Array) {
                if (props.grid.columns instanceof Array)
                    props.grid.columns.forEach(async (col) => {
                        if (col.updateToMain) await updateRowToMain(data, col);
                    });
            }
        }
    };

    const onRowActionCustomData = (e) => {
        var itemObj = { id: e.data.id, code: e.data.code };

        var config = props.grid;
        if (config && config.copyFromHeaderFields instanceof Array)
            config.copyFromHeaderFields.forEach((field) => {
                if (typeof field === 'object') {
                    var parentField = field.field;
                    var aliasField = field.alias ? field.alias : field.field;

                    if (mainData && mainData[parentField] !== undefined) {
                        if (field.when && typeof field.when === 'object') {
                            var isValid = AntCondition.isValid(mainData, {
                                when: field.when,
                                whenType: field.whenType
                            });

                            if (!isValid) return;
                        }
                        itemObj[aliasField] = mainData[parentField];
                    }
                } else if (mainData && mainData[field] !== undefined) itemObj[field] = mainData[field];
            });

        return itemObj;
    };

    const getValidData = async () => {
        var isValid = true;

        if (header.current && header.current.validate) isValid = isValid && (await header.current.validate());
        if (footer.current && footer.current.validate) isValid = isValid && (await footer.current.validate());

        if (!isValid) return null;

        if (grid.current) {
            var mRows = await grid.current.modifiedRows();

            var rows = mRows;

            if (props.grid.selectable) {
                var selectedRows = await grid.current.getSelectedRows();
                rows = selectedRows.map((s) => {
                    var found = mRows.find((m) => m.id === s.id);
                    if (found)
                        return {
                            ...s,
                            ...found
                        };

                    return s;
                });
            }

            var newRows = [];

            if (rows instanceof Array) {
                rows = rows.slice();

                if (props.grid.columns instanceof Array)
                    rows = rows.filter((row) => {
                        for (let j = 0; j < props.grid.columns.length; j++) {
                            const col = props.grid.columns[j];
                            if (col.isMarkSelected && col.dataField) {
                                let value = row[col.dataField];
                                return value !== null && value !== undefined;
                                // return value !== null && value !== undefined && value !== 0;
                            }
                        }

                        return true;
                    });

                if (props.grid && props.grid.postPreFiltering) {
                    rows = rows.filter((row) => {
                        return props.grid.postPreFiltering(row);
                    });
                }

                rows.forEach((row) => {
                    var itemObj = {};

                    if (props.grid && props.grid.postFields instanceof Array)
                        props.grid.postFields.forEach((field) => {
                            if (typeof field === 'object') {
                                var rowField = field.field;
                                var postField = field.alias;

                                itemObj[postField] = row[rowField];
                            } else {
                                itemObj[field] = row[field];
                            }
                        });

                    if (props.grid && props.grid.copyFromHeaderFields instanceof Array)
                        props.grid.copyFromHeaderFields.forEach((field) => {
                            if (typeof field === 'object') {
                                var parentField = field.field;
                                var aliasField = field.alias ? field.alias : field.field;

                                if (mainData && mainData[parentField] !== undefined) {
                                    if (field.when && typeof field.when === 'object') {
                                        var isValid = AntCondition.isValid(mainData, {
                                            when: field.when,
                                            whenType: field.whenType
                                        });

                                        if (!isValid) return;
                                    }
                                    itemObj[aliasField] = mainData[parentField];
                                }
                            } else if (mainData && mainData[field] !== undefined) itemObj[field] = mainData[field];
                        });

                    Object.keys(itemObj).forEach((k) => {
                        if (
                            (typeof itemObj[k] === 'object' && itemObj[k] !== null) ||
                            typeof itemObj[k] === 'function' ||
                            itemObj[k] instanceof Array
                        )
                            itemObj[k] = undefined;
                    });

                    newRows.push({ ...itemObj });
                });
            }

            if (props.grid && props.grid.postRequiredFields instanceof Array) {
                newRows = newRows.filter((row) => {
                    var keys = Object.keys(row).filter((k) => row[k] !== undefined);
                    return props.grid.postRequiredFields.filter((k) => !keys.includes(k)).length <= 0;
                });
            }

            if (props.grid && props.grid.postFiltering) {
                newRows = newRows.filter((row) => {
                    return props.grid.postFiltering(row);
                });
            }

            if (props.grid && props.grid.postModifier) {
                newRows = newRows.map((row) => {
                    return props.grid.postModifier(row, {
                        grid: grid.current,
                        popup: that
                    });
                });
            }

            for (let i = 0; i < newRows.length; i++) newRows[i].row_index = i;

            return newRows;
        }

        return [];
    };

    const onAction = async (button) => {
        var close = false;

        if (button && button.id == 'btnSave') close = await save();

        if (!close && props.onAction) close = await props.onAction(button);

        return close;
    };

    const afterRowAction = (result) => {
        if (props.onCreated)
            setTimeout(
                async (data) => {
                    props.onCreated(data);
                },
                1000,
                result.data
            );

        if (props.navigateLink && result.data) {
            var value;
            var link;

            if (props.navigateLink instanceof Array) {
                props.navigateLink.forEach((l) => {
                    if (l && l.link) {
                        if (l.when && typeof l.when === 'object') {
                            var isValid = AntCondition.isValid(mainData, {
                                when: l.when,
                                whenType: l.whenType
                            });
                            if (!isValid) return;
                        }
                        value = l.field ? result.data[l.field] : result.data.code;
                        link = String(l.link);
                    }
                });
            } else {
                value = props.navigateField ? result.data[props.navigateField] : result.data.code;
                link = String(props.navigateLink);
            }
            if (link && value !== undefined && value !== null) {
                if (!link.startsWith('/')) link = '/' + link;
                if (!link.endsWith('/')) link = link + '/';
                link = link + value;

                navigate(link);
            }
        }
    };

    const save = async () => {
        setError(null);

        var objs = await getValidData();
        if (!objs || objs instanceof Array === false || objs.length <= 0) return false;

        if (props.onSaving) objs = props.onSaving(objs);

        var errors = [];
        var errorContent = null;
        var result = await props.API.postBatchCreateValidation(objs);

        if (result) {
            if (result && result.rows instanceof Array && result.rows.length > 0)
                errors = result.rows.filter((r) => r.error && r.error.code).map((r) => r.error?.error);
            else if (result && typeof result.error === 'string') {
                errors = [result.error];
                errorContent = result.error;
            } else {
                errorContent = AntLocalization.translateText({ vi: 'Không thể truy xuất dữ liệu !', en: 'Connection timeout !', fr: 'Délai de connexion dépassé !', es: '¡Tiempo de conexión agotado!', id: 'Waktu koneksi habis!', ja: '接続がタイムアウトしました！', zh: '连接超时！', ko: '연결 시간 초과!', hi: 'कनेक्शन टाइमआउट!', ar: 'انتهت مهلة الاتصال!' });
                errors = [errorContent];
            }
        }

        if (errors.length <= 0) {
            objs.forEach((obj) => {
                Object.keys(obj).forEach((k) => {
                    if ((typeof obj[k] === 'object' && obj[k] !== null) || typeof obj[k] === 'function' || obj[k] instanceof Array)
                        obj[k] = undefined;
                });
            });
            result = await props.API.postBatchCreate(objs);
            if (!result || result.error || !result.data || result.data.created_qty <= 0) {
                if (result && result.data instanceof Array && result.data.length > 0) errors = result.data;
                else if (result && typeof result.error === 'string') {
                    errors = [result.error];
                    errorContent = result.error;
                } else {
                    errorContent = AntLocalization.translateText({ vi: 'Không thể truy xuất dữ liệu !', en: 'Connection timeout !', fr: 'Délai de connexion dépassé !', es: '¡Tiempo de conexión agotado!', id: 'Waktu koneksi habis!', ja: '接続がタイムアウトしました！', zh: '连接超时！', ko: '연결 시간 초과!', hi: 'कनेक्शन टाइमआउट!', ar: 'انتهت مهلة الاتصال!' });
                    errors = [errorContent];
                }
            }
        }

        if (errors.length > 0) {
            if (!errorContent) errorContent = AntLocalization.translateText({ vi: 'Không thể truy xuất dữ liệu !', en: 'Connection timeout !', fr: 'Délai de connexion dépassé !', es: '¡Tiempo de conexión agotado!', id: 'Waktu koneksi habis!', ja: '接続がタイムアウトしました！', zh: '连接超时！', ko: '연결 시간 초과!', hi: 'कनेक्शन टाइमआउट!', ar: 'انتهت مهلة الاتصال!' });
            setError(errorContent, errors);
            if (props.onError) props.onError(errorContent, errors);
            return false;
        } else {
            if (props.onCreated)
                setTimeout(
                    async (data) => {
                        props.onCreated(data);
                    },
                    1000,
                    result.data
                );

            if (props.navigateLink && result.data) {
                var value;
                var link;

                if (props.navigateLink instanceof Array) {
                    props.navigateLink.forEach((l) => {
                        if (l && l.link) {
                            if (l.when && typeof l.when === 'object') {
                                var isValid = AntCondition.isValid(mainData, {
                                    when: l.when,
                                    whenType: l.whenType
                                });
                                if (!isValid) return;
                            }
                            value = l.field ? result.data[l.field] : result.data.code;
                            link = String(l.link);
                        }
                    });
                } else {
                    value = props.navigateField ? result.data[props.navigateField] : result.data.code;
                    link = String(props.navigateLink);
                }
                if (link && value !== undefined && value !== null) {
                    if (!link.startsWith('/')) link = '/' + link;
                    if (!link.endsWith('/')) link = link + '/';
                    link = link + value;
                    navigate(link);
                }
            }
        }
        return true;
    };

    const [mainState, setMainState] = useState(() => {
        let obj = {
            error: null,
            searchConditions: {}
        };

        return obj;
    });

    const [shouldRender, setShouldRender] = useState(1);

    const mainHeader = useMemo(() => initHeader(mainData), [mainData, shouldRender]);
    const mainFooter = useMemo(() => initFooter(mainData), [mainData, shouldRender]);
    const mainGrid = useMemo(() => initGrid(mainData), [mainData, shouldRender]);

    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);

    const forceRenderWithState = (data) => {
        setMainState((v) => onCustomMainState(Object.assign(v, data), data));
        setShouldRender((v) => v + 1);
    };
    const onCustomMainState = (data, changeData) => {
        data.popupSize = initPopupSize();
        return data;
    };

    const forceRenderWithData = (data, overide) => {
        setMainData((v) => onCustomMainData(v, data, overide));
        setShouldRender((v) => v + 1);
    };

    const onCustomMainData = (data, changeData, overide) => {
        if (overide) {
            if (data && typeof data === 'object') {
                let newObj = JSON.parse(stringify(changeData));

                let keys = Object.keys(data);
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    delete data[key];
                }

                return Object.assign(data, newObj);
            } else return changeData;
        }

        return Object.assign(data, changeData);
    };

    useImperativeHandle(ref, () => ({
        show: show
    }));

    return (
        <React.Fragment>
            {shouldRender && (
                <AntPopup
                    ref={popup}
                    isGray={true}
                    shouldRender={shouldRender + (props.shouldRender ? props.shouldRender : 1)}
                    width={mainState.popupSize ? mainState.popupSize.width : undefined}
                    height={mainState.popupSize ? mainState.popupSize.height : undefined}
                    autoHeight={true}
                    autoWidth={true}
                    title={
                        props.title
                            ? AntLocalization.translateText(props.title)
                            : `${AntLocalization.translateText({ vi: 'Tạo mới', en: 'Create', fr: 'Créer', es: 'Crear', id: 'Buat', ja: '作成', zh: '创建', ko: '생성', hi: 'बनाएं', ar: 'إنشاء' })} ${mainEntityDisplay}`
                    }
                    onAction={onAction}
                    name={`ant-batch-creation-error-${props.API.entityName}`}
                    errors={mainState.error ? mainState.error.values : undefined}
                    errorText={mainState.error ? mainState.error.text : undefined}
                    separateErrorLine={props.separateErrorLine}
                    hideOnOutsideClick={props.hideOnOutsideClick !== undefined ? props.hideOnOutsideClick : true}
                    widgets={[
                        {
                            id: 'btnSave',
                            type: 'button',
                            icon: 'save',
                            text: AntLocalization.translateText({ vi: 'Tạo', en: 'Create', fr: 'Créer', es: 'Crear', id: 'Buat', ja: '作成', zh: '创建', ko: '생성', hi: 'बनाएं', ar: 'إنشاء' }),
                            waiting_text: AntLocalization.translateText({ vi: 'Chờ xử lý', en: 'Processing', fr: 'Traitement', es: 'Procesando', id: 'Memproses', ja: '処理中', zh: '处理中', ko: '처리 중', hi: 'प्रसंस्करण', ar: 'جاري المعالجة' }),
                            width: 130
                        }
                    ]}
                >
                    {/* {mainState.error && (
                        <AntErrorPanel
                            errors={mainState.error.values}
                            id={`ant-batch-creation-error-${props.API.entityName}`}
                            text={mainState.error.text}
                        />
                    )} */}

                    <Box direction="col" width="100%" height="100%">
                        {mainHeader && mainHeader.headerVisible && (
                            // <BoxItem baseSize={mainHeader.headerHeight}>
                            <BoxItem baseSize={'auto'}>
                                <AntBaseForm
                                    ref={header}
                                    type={'Create'}
                                    formData={mainData}
                                    shouldRender={shouldRender + (props.shouldRender ? props.shouldRender : 1)}
                                    table={props.header ? props.header.table : props.table}
                                    API={props.header && props.header.API ? props.header.API : props.API}
                                    default={props.header ? props.header.default : undefined}
                                    parentData={props.parentData}
                                    parentFK={props.parentFK}
                                    alignItemLabelsInAllGroups={props.header ? props.header.alignItemLabelsInAllGroups : undefined}
                                    labelLocation={props.header ? props.header.labelLocation : undefined}
                                    colCount={props.header ? props.header.colCount : 1}
                                    colCountDefault={props.header ? props.header.colCountDefault : undefined}
                                    prepare={false}
                                    byPassRequired={true}
                                    disabled={props.header && props.header.disabled !== undefined ? props.header.disabled : undefined}
                                    fields={props.header ? props.header.fields : []}
                                    items={mainHeader ? mainHeader.headerItems : []}
                                    postFields={props.header ? props.header.postFields : undefined}
                                    onFieldDataChanged={onFieldDataChanged}
                                    onError={setError}
                                />
                                {mainHeader && mainHeader.headerVisible && (!props.header || !props.header.noSeparator) && (
                                    <p style={{ marginBlockStart: '0px', marginBlockEnd: '10px' }} />
                                )}
                            </BoxItem>
                        )}

                        {mainGrid && mainGrid.gridVisible && (
                            <BoxItem ratio={1}>
                                <AntGridScope segment={buildGridScopeSegment('popup', 'batch-create', props.table || (props.API && props.API.entityName))}>
                                <AntGrid
                                    ref={grid}
                                    API={props.grid && props.grid.API ? props.grid.API : props.API}
                                    url={mainGrid.gridURL}
                                    table={props.grid ? props.grid.table : props.table}
                                    keyExpr={'id'}
                                    shouldRender={shouldRender + (props.shouldRender ? props.shouldRender : 1)}
                                    height={props.grid ? props.grid.height : undefined}
                                    rowActions={props.grid ? props.grid.rowActions : undefined}
                                    rowActionCustomData={onRowActionCustomData}
                                    afterRowAction={afterRowAction}
                                    rowStyles={props.grid ? props.grid.rowStyles : undefined}
                                    cellStyles={props.grid ? props.grid.cellStyles : undefined}
                                    parentTable={mainTable}
                                    parentData={mainData}
                                    searchConditions={getSearchConditions}
                                    searchFields={mainGrid.gridSearchFields.length > 0 ? mainGrid.gridSearchFields : undefined}
                                    isAllowQuery={isAllowQuery}
                                    storageKey={mainGrid.gridStorageKey}
                                    remotePaging={props.grid.remotePaging !== undefined ? props.grid.remotePaging : true}
                                    defaultPageSize={props.grid.defaultPageSize ? props.grid.defaultPageSize : 8}
                                    showPageSizeSelector={false}
                                    // pagerHideable={true}
                                    isSearching={true}
                                    allowEdit={!mainGrid.gridDisabled && (props.grid.allowEdit !== undefined ? props.grid.allowEdit : true)}
                                    allowNew={!mainGrid.gridDisabled && (props.grid.allowNew !== undefined ? props.grid.allowNew : false)}
                                    fields={props.grid.fields}
                                    columns={mainGrid.gridCols}
                                    rawColumns={mainGrid.gridRawCols}
                                    customSelectionValue={props.grid.customSelectionValue}
                                    keyboardNavigation={props.keyboardNavigation}
                                    actionItems={props.grid.actionItems}
                                    scheduler={props.grid.scheduler}
                                    cardview={props.grid.cardview}
                                    onAction={props.grid.onAction}
                                    // onLoaded={forceRender}
                                    ordering={props.grid.ordering}
                                    orderBy={props.grid.orderBy}
                                    orderType={props.grid.orderType}
                                    showIndex={props.grid.showIndex}
                                    showDetail={props.grid.showDetail}
                                    showDetailOnNewWindow={true}
                                    showDetailPosition="right"
                                    showActionBar={props.grid.showActionBar}
                                    showRefresh={props.grid.showRefresh}
                                    showSelectAll={props.grid.showSelectAll}
                                    search={props.grid && props.grid.search ? props.grid.search : props.search}
                                    selectable={props.grid.selectable}
                                    selectionMode={props.grid.selectionMode}
                                    showFilterBySelected={props.grid.showFilterBySelected}
                                    showSearchBar={props.grid.showSearchBar !== undefined ? props.grid.showSearchBar : true}
                                    searchBarWidth={props.grid.searchBarWidth}
                                    showFieldChooser={props.grid.showFieldChooser}
                                    locationRefresh={props.grid.locationRefresh}
                                    locationFilterBySelected={props.grid.locationFilterBySelected}
                                    locationSearchBar={props.grid.locationSearchBar}
                                    onDataSourceEdited={onGridCellValueChanged}
                                    // onCellValueChanging={this.onGridCellValueChanging.bind(this)}
                                    getQueryFields={() => {
                                        if (!props.grid.postFields) return [];
                                        return Array.from(props.grid.postFields, (f) => {
                                            if (typeof f === 'string') {
                                                return String(f);
                                            } else if (typeof f === 'object' && f.field) return f.field;
                                        });
                                    }}
                                    autoScan={props.grid.autoScan}
                                    searchCategories1={props.grid.searchCategories1}
                                    searchCategories2={props.grid.searchCategories2}
                                    searchCategories3={props.grid.searchCategories3}
                                    searchCategories4={props.grid.searchCategories4}
                                    searchCategories5={props.grid.searchCategories5}
                                    searchCategories6={props.grid.searchCategories6}
                                    searchCategories7={props.grid.searchCategories7}
                                    searchCategories8={props.grid.searchCategories8}
                                    searchCategories9={props.grid.searchCategories9}
                                    searchCategories10={props.grid.searchCategories10}
                                    byPassCachingStates={props.grid.byPassCachingStates}
                                />
                                </AntGridScope>
                            </BoxItem>
                        )}

                        {mainFooter && mainFooter.footerVisible && (
                            // <BoxItem baseSize={mainFooter.footerHeight}>

                            <BoxItem baseSize={'auto'}>
                                {mainFooter && mainFooter.footerVisible && (!props.footer || !props.footer.noSeparator) && (
                                    <p style={{ marginBlockStart: '0px', marginBlockEnd: '30px' }} />
                                )}
                                <AntBaseForm
                                    ref={footer}
                                    type={'Create'}
                                    shouldRender={shouldRender + (props.shouldRender ? props.shouldRender : 1)}
                                    table={props.footer ? props.footer.table : props.table}
                                    formData={mainData}
                                    default={props.footer ? props.footer.default : undefined}
                                    parentData={props.parentData}
                                    parentFK={props.parentFK}
                                    API={props.footer && props.footer.API ? props.footer.API : props.API}
                                    alignItemLabelsInAllGroups={props.footer ? props.footer.alignItemLabelsInAllGroups : undefined}
                                    labelLocation={props.footer ? props.footer.labelLocation : undefined}
                                    colCount={props.footer ? props.footer.colCount : 1}
                                    colCountDefault={props.footer ? props.footer.colCountDefault : undefined}
                                    prepare={false}
                                    byPassRequired={true}
                                    disabled={props.footer && props.footer.disabled !== undefined ? props.footer.disabled : undefined}
                                    fields={props.footer ? props.footer.fields : []}
                                    items={mainFooter ? mainFooter.footerItems : []}
                                    postFields={props.footer ? props.footer.postFields : undefined}
                                    onFieldDataChanged={onFieldDataChanged}
                                    onError={setError}
                                />
                            </BoxItem>
                        )}
                    </Box>
                </AntPopup>
            )}
        </React.Fragment>
    );
});
